(function () {
    'ngInject';

    angular.module('app.shared.services').factory('StripeCheckoutAPIService', stripeCheckoutAPIService);

    function stripeCheckoutAPIService(HttpService) {
        function createCheckoutSession(username, data) {
            return HttpService.post('/Stripe/CreateCheckoutSession/' + username, data);
        }

        return {
            createCheckoutSession: createCheckoutSession
        };
    }
})();
